import styled from 'styled-components';

export const ClamshellPreview = styled.div<{ show: boolean }>`
  display: ${({ show }) => (show ? 'inline' : 'none')};
`;

export const ClamshellPreviewTitle = styled.div`
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 2%;
  display: flex;
  align-items: center;
  span:nth-child(2) {
    margin-left: 10px;
  }
`;

export const ClamshellPreviewImage = styled.div`
  position: relative;
  z-index: 0;
`;

export const QRCodeDrawingArea = styled.div<{ showBorder: boolean }>`
  position: absolute;
  width: 300px;
  height: 105px;
  z-index: 100;
  top: 270px;
  left: 105px;
  border: ${({ showBorder }) =>
    showBorder ? '2px dotted rgba(244, 244, 244, 1)' : 'none'};
`;

export const ClamshellPreviewActionButtons = styled.div`
  margin-top: 8%;

  display: flex;
  align-items: center;
  justify-content: center;
  /*  */
  button:nth-child(2) {
    margin-left: 20px;
  }
  button:nth-child(3) {
    margin-left: 20px;
  }
`;

export const LogoDrawingArea = styled.div<{ showBorder: boolean }>`
  position: absolute;
  width: 300px;
  height: 105px;
  z-index: 100;
  top: 95px;
  left: 105px;
  border: ${({ showBorder }) =>
    showBorder ? '2px dotted rgba(244, 244, 244, 1)' : 'none'};
`;

export const HelperText = styled.div<{ displayText: boolean }>`
  display: ${({ displayText }) => (displayText ? 'inline' : 'none')};
  color: white;
  font-size: 1.3rem;
  position: absolute;
  top: 50%;
  left: 50%;

  /* translate(<x value>, <y value>) */
  transform: translate(-50%, -50%);
  font-style: italic;
  text-align: center;
`;

export const DesignPreviewGalleryWrapper = styled.div`
  margin-bottom: 1rem;
  width: 510px;
  height: 510px;
  display: flex;
  align-items: center;

  ${({ theme }) => theme.breakpoints.up('lg')} {
    min-height: 484px;
  }

  .image-gallery-thumbnail {
    border-radius: 4px;
  }
  .image-gallery-thumbnail.active {
    border: 2px solid rgba(0, 0, 0, 0.94);
  }

  .image-gallery-thumbnail:hover {
    border: 2px solid rgba(0, 0, 0, 0.94);
  }

  .image-gallery-thumbnail-inner {
    margin: 0 auto;
  }

  /* .image-gallery-slide-wrapper {
    left: 10px;
  }

  .image-gallery-slide {
    margin-bottom: 50px;
  } */

  .image-gallery-thumbnails {
    overflow-y: scroll;
  }
`;

export const IconWrapper = styled.div`
  margin-right: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ActionToolbarButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 2%;
  margin-right: 4px;
  > button:only-child {
    margin: 0 auto;
  }
`;
